import MicroRegiaoList from './list';

export default function MicroRegiaoPage() {
  return <MicroRegiaoList />;
}
